module.exports = __webpack_public_path__ + "img/shifts-teams.084a245f.svg";